import { useState } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [formMessage, setFormMessage] = useState('');
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const formActionUrl = 'https://readdy.ai/api/form/d9q39t4nlsngrm4llqq0';

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = (formData.get('phone_alt') as string || '').trim();
    if (honeypot) {
      setFormMessage('感谢订阅！');
      setFormStatus('success');
      return;
    }
    formData.delete('phone_alt');
    try {
      const res = await fetch(formActionUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: any;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }
      if (res.ok && parsed?.code === 'OK') {
        setFormMessage('感谢订阅！我们会将最新资讯发送到您的邮箱。');
        setFormStatus('success');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || '订阅失败，请稍后重试。';
        setFormMessage(serverMsg.includes('spam') ? '订阅失败，请稍后重试。' : serverMsg);
        setFormStatus('error');
      }
    } catch {
      setFormMessage('网络错误，请稍后重试。');
      setFormStatus('error');
    }
  };

  return (
    <section className="py-16 md:py-20 bg-background-900">
      <div className="max-w-2xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-3xl md:text-4xl text-background-50 mb-4">
          订阅我们的资讯
        </h2>
        <p className="text-background-400 text-sm mb-8">
          获取最新的白丝JK周边发售信息、穿搭指南和同人文化动态
        </p>
        <form
          onSubmit={handleSubmit}
          data-readdy-form
          className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
        >
          <div className="form-honeypot">
            <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
          </div>
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="输入你的邮箱地址"
            required
            className="flex-1 px-5 py-3 rounded-full bg-background-700 border border-background-600 text-background-100 text-sm placeholder:text-background-500 focus:outline-none focus:border-primary-400 transition-colors duration-200"
          />
          <button
            type="submit"
            className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            订阅
          </button>
        </form>
        {formMessage && (
          <p className={`mt-4 text-sm ${formStatus === 'success' ? 'text-accent-400' : 'text-red-400'}`}>
            {formMessage}
          </p>
        )}
      </div>
    </section>
  );
}